export default __webpack_public_path__ + "static/media/fullscreenLight.b480e8f6.svg";